
import * as commonApis from './commonApis'
import { API_HOST_NAME } from 'constants/SystemConstant';

export const getList = (page, callback, callbackErr) => {
    let url = API_HOST_NAME + '/api/customers';
    let params = []
    if (page) {
        params.push({
            name: 'page',
            value: page
        })
    }
    let token = localStorage.getItem("token")
    commonApis.GET(url, token, params, callback, callbackErr);
}
export const getListCustomer = (params, callback, callbackErr) => {
    let url = API_HOST_NAME + '/api/customers';
    let token = localStorage.getItem("token")
    commonApis.GET(url, token, params, callback, callbackErr);
}
export const get = (id, callback, callbackErr) => {
    let url = API_HOST_NAME + '/api/customers/' + id;
    let token = localStorage.getItem("token")
    commonApis.GET(url, token, '', callback, callbackErr);

}
export const create = (data, callback, callbackErr) => {
    let url = API_HOST_NAME + '/api/customers';

    let token = localStorage.getItem("token")
    commonApis.POST(url, data, token, '', callback, callbackErr)

}
export const update = (id, data, callback, callbackErr) => {
    let url = API_HOST_NAME + '/api/customers/' + id;
    let token = localStorage.getItem("token")
    commonApis.PUT(url, data, token, '', callback, callbackErr)

}